import { css  } from '@emotion/core'
import { mq } from '../../cssInJs'

export default {
  top: css(mq({
    //height: [44, null, 80],
    height: [44, null, 56],
    background: 'black',
    position: 'fixed',
    width: '100%',
    zIndex: '999',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.3s'
  })),
  // topScrolled: css(mq({
  //   height: [44, null, 56],
  // })),
  logo: css(mq({
  })),
  logoImg: css(mq({
    display: 'block',
    height: [112, null, 176],
    marginTop: ['5.5rem', null, '7rem'],
    transition: 'all .2s',
    opacity: 1,
  })),
  logoImgHidden: css(mq({
    opacity: 0,
    height: 0,
    marginTop: 0,
    overflow: 'hidden',
    transition: 'all .2s',
  })),
  logoScrolled: css(mq({
    img: css(mq({
      height: [70, null, 110],
      marginTop: ['3rem', null, '3.5rem'],
    }))
  })),

  logo2Img: css(mq({
    position: 'absolute',
    height: ['32px', null, '44px'],
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    opacity: 0,
    transition: 'all .3s',
    pointerEvents: 'none',
  })),
  logo2ImgVisible: css(mq({
    opacity: 1,
    pointerEvents: 'auto',
  }))
}